import React from 'react'
import {View, TouchableOpacity} from 'react-native'
import HMTextView from "../HMTextView";
import HMIcon from "../HMIcon";



class EventView extends React.Component {
    setStyles = (styles) => {
        this.root.setNativeProps({
            style: styles,
        })
    }

    state = {
        hover: false
    }

    render() {
        const {
            activeStyle, styleHoverIcon, hoverStyle, style, onPressIn, onPressOut,

            textName, textHoverStyle, textStyle,
            onPress,

            typeIcon,
            uriIcon,
            heightIcon,
            widthIcon,
            nameIcon,
            styleIcon,
            sourceIcon,
            sourceHoverIcon,
            ...passThrough


        } = this.props;

        const CustomView = onPress ? TouchableOpacity : View

        return (
            <CustomView
                ref={(component) => {
                    this.root = component
                }}
                onPress={onPress}
                onMouseEnter={
                    () => {
                        //   this.setStyles(hoverStyle)
                        this.setState({hover: true})
                    }
                }
                onMouseLeave={

                    () => {
                        //this.setStyles(style)
                        this.setState({hover: false})
                    }
                }
                onStartShouldSetResponder={() => true}
                onResponderStart={
                    () => {
                        //  this.setStyles(activeStyle)
                    }
                }
                onResponderRelease={
                    () => {
                        //this.setStyles(this.state.hover ? hoverStyle : style)
                    }
                }
                // style={style}
                style={this.state.hover ? hoverStyle : style}
                {...passThrough}
            >
                {/*   <HMIcon

                    //source={require('../../../../../assets/img/success.png')}
                    //source={PathFile.image.background}
                    //svg={PathFile.svg.add}
                    type={"svg"}
                    source={PathFile.svg.add}
                    height={moderateScale(22)}
                    width={moderateScale(22)}

                    style={{
                        // fontSize: moderateScale(20),
                        // color: Colors.blue,
                        // marginHorizontal: moderateScale(4),
                        marginRight: moderateScale(4),
                        marginLeft: moderateScale(4),
                        //  marginTop: moderateScale(3)
                    }}
                />*/}
                {
                    nameIcon || sourceIcon || uriIcon ?
                        <HMIcon

                            //source={require('../../../../../assets/img/success.png')}
                            //source={PathFile.image.background}
                            //svg={PathFile.svg.add}
                            type={typeIcon}
                            uri={uriIcon}
                            source={this.state.hover ? sourceHoverIcon : sourceIcon}
                            height={heightIcon}
                            width={widthIcon}

                            name={nameIcon}
                            style={this.state.hover ? styleHoverIcon : styleIcon}


                        />
                        :
                        null
                }

                <HMTextView
                    numberOfLines={2}
                    type={"bold"}
                    // text={" اگر در سازمان شما هم افراد مغرور و شخصیت های قوی وجود دارد لازم است بدانید، هنر فرگوسن این بود که به تمام"}
                    text={textName}
                    style={this.state.hover ? textHoverStyle : textStyle}/>
            </CustomView>
        )
    }
}

export default EventView
